import tick from "../../assets/green-tick-teams.svg"
import run_summary from "../../assets/run-summary.svg"
import info from "../../assets/info-icon.png"
import {useEffect, useState} from "react";
import teams_api from "../../api/protected/teams"
import {useNavigate} from "react-router-dom";
import arrow from "../../assets/mobile-menu-expandable-close.svg"


const TeamsCard = (props) => {

    const navigate = useNavigate()
    const [survey, setSurvey] = useState(null)

    const [showInfoHover, setShowInfoHover] = useState(false)
    const [mobileCollapsed, setMobileCollapsed] = useState(false)

    useEffect(() => {
        if(!props.team_id) return;
        getLatestSurvey()
    }, [props.team_id]);

    const getLatestSurvey = () => {
        let response = teams_api.getLatestSurvey(props.team_id, false);
        response.then(response => {
            setSurvey(response.data)
        }).catch(err => console.log(err))
    }

    const formatDate = (timestamp) => {
        let current_date = new Date(timestamp * 1000);
        return `${current_date.getDate()}/${current_date.getMonth() + 1}/${current_date.getFullYear()}`
    }

    const handleScroll = (ev) => {
        let handleMax = 193
        let height = 256
        let scrollHeight = ev.target.scrollHeight - height
        let multiplier = 0

        if (ev.target.scrollTop) {
            multiplier = (ev.target.scrollTop / scrollHeight)
        }

        let elem = document.getElementById('scroll-handle')
        if (elem){
            elem.style.top = `${Math.round(handleMax * multiplier)}px`
        }
    }

    const handleSummaryClick = (ev) => {
        if(!ev) return;
        navigate(`/teams/${props.team_id}`)
    }

    const handleManageClick = (ev, id) => {
        if (!survey) return;
        navigate(`/surveys/${id}?overview=true`)
    }

    const canShowRunSummary = () => {
        let completedCount = 0;

        for (const p of survey.participants) {
            if (p.completion >= 100) {
                completedCount++;
                if (completedCount >= 2) return true;
            }
        }

        return false;
    }


    return (
        <div className="dashboard-team-card-container" style={{minHeight: mobileCollapsed ? "unset" : "", paddingBottom: mobileCollapsed ? "unset" : ""}}>
            <div className="dashboard-team-card-top-row" style={{borderBottom: mobileCollapsed ? "unset" : ""}}>
                <div className="dashboard-team-card-details">
                    <div className="dashboard-team-card-colour-circle" style={{backgroundColor: `#${survey?.colour}`}}/>
                    <div className="dashboard-team-card-organisation-name bold">Team Status:</div>
                    <div className="dashboard-team-card-team-name regular hide-mobile">{survey?.organisation_name},</div>
                    <div className="dashboard-team-card-team-name regular hide-mobile">{survey?.team_name}</div>
                    <div className="dashboard-team-card-name-container-mobile">
                        <div className="dashboard-team-card-name bold">{survey?.organisation_name}</div>
                        <div className="dashboard-team-card-name regular">{survey?.team_name}</div>
                    </div>
                    <img src={info} alt="Info"
                         onMouseOver={() => setShowInfoHover(true)}
                         onMouseLeave={() => setShowInfoHover(false)}
                    />
                    {showInfoHover ?
                        <div className="dashboard-roi-title-hover" style={{top: 40, left: 304}}>
                            <div className="dashboard-roi-title-hover-triangle-outer">
                                <div className="dashboard-roi-title-hover-triangle-inner"/>
                            </div>
                            <div className="dashboard-roi-title-hover-text regular">
                                This card shows an overview of the Teams latest survey and responses. Use the SEE TEAM
                                PAGE button to view and manage the team.
                            </div>
                        </div> : null
                    }
                </div>
                <div className="dashboard-mobile-collapse-button" onClick={() => setMobileCollapsed(!mobileCollapsed)}>
                    <img src={arrow} className={mobileCollapsed ? "rotate-180" : ""}/>
                </div>
                <div className="dashboard-team-card-row-container">
                    <div className="edit-team-latest-survey-run-summary-button dashboard" onClick={handleSummaryClick}>
                        <div className="edit-team-latest-survey-run-summary-text bold">SEE TEAM PAGE</div>
                    </div>
                    {survey && canShowRunSummary() ?
                        <div className={"edit-team-latest-survey-run-summary-button small"}
                             onClick={ev => handleManageClick(ev, survey?.id)}>
                            <div className="edit-team-latest-survey-run-summary-img">
                                <img src={run_summary} alt="Run summary"/>
                            </div>
                        </div>
                        : null
                    }
                </div>
            </div>
            <div className="dashboard-team-card-bottom-row" style={{display: mobileCollapsed ? "none" : ""}}>
                <div className="edit-team-latest-survey-left">
                    <div className="edit-team-latest-survey-title bold">Latest Survey</div>
                    <div className="edit-team-latest-survey-divider hide-mobile" style={{width: 346}}/>
                    <div className="team-card-mobile-wrap-container">
                        <div className="edit-team-latest-survey-subtitle mobile-spaced bold top-margin-30">Survey Type
                        </div>
                        <div className="edit-team-latest-survey-light-row">
                            <div className="latest-survey-light-container">
                                <div className={`latest-survey-light ${survey && survey.type === 2 ? "filled" : ""}`}/>
                                <div className="latest-survey-light-text">Lite</div>
                            </div>
                            <div className="latest-survey-light-container">
                                <div className={`latest-survey-light ${survey && survey.type === 1 ? "filled" : ""}`}/>
                                <div className="latest-survey-light-text">Full</div>
                            </div>
                        </div>
                    </div>
                    <div className="team-card-mobile-wrap-container">
                        <div className="edit-team-latest-survey-subtitle mobile-spaced bold">Survey Point</div>
                        <div className="edit-team-latest-survey-light-row">
                            <div className="latest-survey-light-container wide">
                                <div className={`latest-survey-light ${survey && survey.point === 1 ? "filled" : ""}`}/>
                                <div className="latest-survey-light-text">Initial</div>
                            </div>
                            <div className="latest-survey-light-container wide">
                                <div className={`latest-survey-light ${survey && survey.point === 2 ? "filled" : ""}`}/>
                                <div className="latest-survey-light-text">Midpoint</div>
                            </div>
                            <div className="latest-survey-light-container wide">
                                <div className={`latest-survey-light ${survey && survey.point === 3 ? "filled" : ""}`}/>
                                <div className="latest-survey-light-text">Endpoint</div>
                            </div>
                            <div className="latest-survey-light-container very-wide">
                                <div className={`latest-survey-light ${survey && survey.point === 4 ? "filled" : ""}`}/>
                                <div className="latest-survey-light-text">Post Engagement</div>
                            </div>
                        </div>
                    </div>
                    <div className="edit-team-latest-survey-divider w-346-mtop-45"/>
                    <div className="edit-team-latest-survey-key-value-container">
                        <div className="edit-team-latest-survey-subtitle bold">Number of Participants:</div>
                        <div className="edit-team-latest-survey-value bold">{survey && survey.participants.length}</div>
                    </div>
                    <div className="edit-team-latest-survey-divider w-346-mbottom-15"/>
                    <div className="edit-team-latest-survey-dates-container">
                        <div className="latest-survey-date">
                            <div className="edit-team-latest-survey-subtitle bold">Issue Date</div>
                            <div
                                className="latest-survey-date-value regular">{survey && formatDate(survey.created_date)}</div>
                        </div>
                        <div className="latest-survey-date">
                            <div className="edit-team-latest-survey-subtitle bold">Expiry Date</div>
                            <div
                                className="latest-survey-date-value regular">{survey && formatDate(survey.expiry_date)}</div>
                        </div>
                    </div>
                </div>
                <div className="edit-team-latest-survey-right">
                    <div className="edit-team-latest-survey-title bold">Survey Completion by Participants</div>
                    <div className="dashboard-teams-card-completion-box-container">
                        <div
                            className="dashboard-teams-card-completion-box bold">{survey && Math.round(survey.completion_avg)}%
                        </div>
                        <div className="dashboard-teams-card-completion-text regular">OVERALL COMPLETION</div>
                    </div>
                    <div className="edit-team-latest-survey-scroll-container">
                        <div className="edit-team-latest-survey-scroll-area" onScroll={handleScroll}>
                            {survey && survey.participants.map((participant, idx) => {
                                return (
                                    <div className="edit-team-latest-survey-scroll-row" key={idx}>
                                        <div className="edit-team-latest-survey-scroll-details">
                                            <div className="edit-team-latest-survey-scroll-details-name-container bold">
                                                <div className="scroll-row-text">{participant.name}</div>
                                                <div className="scroll-row-text">{participant.completion}%</div>
                                            </div>
                                            <div className="edit-team-latest-survey-progress-bar-container">
                                                <div className="edit-team-latest-survey-progress-bar-lower"/>
                                                <div
                                                    className={`edit-team-latest-survey-progress-bar ${participant.completion === 100 ? "complete" : ""}`}
                                                    style={{width: `${participant.completion}%`}}/>
                                            </div>
                                        </div>
                                        <div className="edit-team-latest-survey-scroll-circle">
                                            {participant.completion === 100 ? <img src={tick} alt="Complete"/> : null}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <div className="edit-team-latest-survey-run-summary-button mobile-only dashboard" style={{display: mobileCollapsed ? "none" : ""}}
                 onClick={handleSummaryClick}>
                <div className="edit-team-latest-survey-run-summary-text bold">SEE TEAM PAGE</div>
                <div className="edit-team-latest-survey-run-summary-img">
                    <img src={run_summary} alt="SEE TEAM PAGE"/>
                </div>
            </div>
        </div>
    )
}


export default TeamsCard